export function createNotificationLedger(seedReadKeys = new Set()) {
  const ledger = {};

  seedReadKeys.forEach((notificationId) => {
    ledger[notificationId] = {
      read: true,
      read_at: null,
    };
  });

  return ledger;
}

export function markNotificationReadInLedger(ledger, notificationId, readAt = new Date().toISOString()) {
  return {
    ...ledger,
    [notificationId]: {
      read: true,
      read_at: readAt,
    },
  };
}

export function markAllNotificationsReadInLedger(ledger, candidateNotifications, readAt = new Date().toISOString()) {
  return candidateNotifications.reduce((nextLedger, notification) => ({
    ...nextLedger,
    [notification.id]: {
      read: true,
      read_at: readAt,
    },
  }), { ...ledger });
}
